import { DateTime } from "luxon";

export default class base {
    dates = [];
    integers = [];
    setDateZone = true;

    setUp(instance, data) {
        Object.assign(instance, data);
        instance.dates.forEach((item) => {
            if (instance.hasOwnProperty(item) && instance[item]) {
                instance[item] = DateTime.fromISO(instance[item].toString(), {
                    setZone: instance.setDateZone || this.setDateZone
                });
            }
        });

        instance.integers.forEach((item) => {
            if (instance.hasOwnProperty(item) && instance[item]) {
                instance[item] = parseInt(instance[item]) || 0;
            }
        });
    }
}